import React, { useEffect } from 'react'
import "./contact.scss"
import {BsFacebook, BsFillTelephoneFill, BsTelegram} from "react-icons/bs"
import {RiWhatsappFill} from "react-icons/ri"
import {MdEmail} from "react-icons/md"
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from '../Footer/Footer'

function Contact() {
  useEffect(() => {
    window.scrollTo({
      behavior:"smooth",
      top:0
    })
    AOS.init({ duration: 1000 });
  },[])
  return (
    <>
    <div className='contact' data-aos="flip-left">
      <a target='_blank' href="tel:+963115659481"><BsFillTelephoneFill/> +011 5659481</a>
      <a target='_blank' href=""><BsFillTelephoneFill/> +963 954006974</a>
      <a target='_blank' href=""><BsFillTelephoneFill/> +963 943124121</a>
      <a target='_blank' href=""><BsFillTelephoneFill/> +963 955520981</a>
      <a target='_blank' href=""><BsTelegram/> Telgram</a>
      <a target='_blank' href="https://chat.whatsapp.com/6Fi3unOroQaFQzjbcLMAVy"><RiWhatsappFill/> Whatsapp</a>
      <a target='_blank' href="https://www.facebook.com/kanafanitravel/"><BsFacebook/> Facebook</a>
      <a target='_blank' href="https://www.facebook.com/groups/241228949771661/"><BsFacebook/> Facebook Group</a>
      <a target='_blank' href="mailto:kanafanitravelagency@gmail.com"><MdEmail/>E-Mail</a>
    </div>
    <Footer/>
    </>
  )
}

export default Contact